(() => {
  if (window.__KervelanCollectionSortLoaded) return;
  window.__KervelanCollectionSortLoaded = true;

  const allowedSorts = new Map([
    ['manual', 'Featured'],
    ['best-selling', 'Best selling'],
    ['price-ascending', 'Price, low to high'],
    ['price-descending', 'Price, high to low'],
    ['created-descending', 'Date, new to old'],
  ]);

  const desktopQuery = window.matchMedia('(min-width: 750px)');
  const collectionSelector = 'collection-component.kervelan-collection';
  const componentSelector = `${collectionSelector} sorting-filter-component`;

  const navigateToSort = (value, component) => {
    if (!allowedSorts.has(value)) return;

    const url = new URL(window.location.href);
    const current = url.searchParams.get('sort_by');
    url.searchParams.set('sort_by', value);
    url.searchParams.delete('page');

    const details = component?.querySelector('details');
    if (details instanceof HTMLDetailsElement) details.open = false;

    if (current === value) return;

    const update = window.KervelanCollectionHistory?.applySort?.(value);
    if (update) return;

    window.location.replace(url.toString());
  };

  const rewriteIds = (component, index) => {
    const token = `kv-sort-${index}`;

    const select = component.querySelector('select[name="sort_by"]');
    const selectLabel = select?.closest('.sorting-filter__container')?.querySelector('label[for]');
    if (select instanceof HTMLSelectElement) {
      select.id = `${token}-select`;
      if (selectLabel instanceof HTMLLabelElement) selectLabel.htmlFor = select.id;
    }

    const details = component.querySelector('details');
    const summary = details?.querySelector('summary');
    const listbox = details?.querySelector('[role="listbox"]');
    const title = summary?.querySelector('.facets__label');

    if (details instanceof HTMLDetailsElement) details.id = `${token}-details`;
    if (listbox instanceof HTMLElement) listbox.id = `${token}-options`;
    if (summary instanceof HTMLElement && listbox instanceof HTMLElement) {
      summary.setAttribute('aria-controls', listbox.id);
    }
    if (title instanceof HTMLElement) title.id = `${token}-label`;
    if (listbox instanceof HTMLElement && title instanceof HTMLElement) {
      listbox.setAttribute('aria-labelledby', title.id);
    }

    component.querySelectorAll('input[type="radio"][name="sort_by"]').forEach((input, optionIndex) => {
      if (!(input instanceof HTMLInputElement)) return;
      const label = input.closest('label');
      input.id = `${token}-option-${optionIndex}`;
      if (label instanceof HTMLLabelElement) label.htmlFor = input.id;
    });
  };

  const enhanceComponent = (component, index) => {
    if (!(component instanceof HTMLElement)) return;
    if (component.dataset.kvSortEnhanced === 'true') return;

    component.dataset.kvSortEnhanced = 'true';
    component.classList.add('kervelan-sort');

    component.querySelectorAll('.facets__summary .facets__label, .sorting-filter__container > .facets__label').forEach((label) => {
      if (label.textContent !== 'SORT BY') label.textContent = 'SORT BY';
    });

    component.querySelectorAll('select[name="sort_by"] option').forEach((option) => {
      if (!(option instanceof HTMLOptionElement)) return;
      const label = allowedSorts.get(option.value);
      if (!label) {
        option.remove();
        return;
      }
      if (option.textContent !== label) option.textContent = label;
    });

    component.querySelectorAll('input[type="radio"][name="sort_by"]').forEach((input) => {
      if (!(input instanceof HTMLInputElement)) return;
      const labelText = allowedSorts.get(input.value);
      const outerLabel = input.closest('label');

      if (!labelText) {
        outerLabel?.remove();
        return;
      }

      input.dataset.optionName = labelText;
      const text = outerLabel?.querySelector('.sorting-filter__label');
      if (text instanceof HTMLElement && text.textContent !== labelText) text.textContent = labelText;
    });

    const selectedValue =
      component.querySelector('input[type="radio"][name="sort_by"]:checked')?.value ||
      component.querySelector('select[name="sort_by"]')?.value;
    const status = component.querySelector('.facets__status');
    if (status instanceof HTMLElement && selectedValue && allowedSorts.has(selectedValue)) {
      const label = allowedSorts.get(selectedValue) || '';
      if (status.textContent !== label) status.textContent = label;
    }

    rewriteIds(component, index);
  };

  const enhanceAll = (root = document) => {
    if (!desktopQuery.matches) return;

    if (root instanceof Element && root.matches(componentSelector)) {
      enhanceComponent(root, 0);
      return;
    }

    root.querySelectorAll?.(componentSelector).forEach((component, index) => enhanceComponent(component, index));
  };

  window.addEventListener(
    'click',
    (event) => {
      if (!desktopQuery.matches) return;
      const target = event.target;
      if (!(target instanceof Element)) return;

      const component = target.closest(`${componentSelector}.kervelan-sort`);
      if (!(component instanceof HTMLElement)) return;

      let input;
      const option = target.closest('.sorting-filter__option');
      if (option) input = option.querySelector('input[type="radio"][name="sort_by"]');

      if (!(input instanceof HTMLInputElement)) {
        const label = target.closest('label');
        if (label instanceof HTMLLabelElement && label.control?.name === 'sort_by') input = label.control;
      }

      if (!(input instanceof HTMLInputElement) || !allowedSorts.has(input.value)) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      navigateToSort(input.value, component);
    },
    true
  );

  window.addEventListener(
    'change',
    (event) => {
      if (!desktopQuery.matches) return;
      const target = event.target;
      if (!(target instanceof HTMLSelectElement) || target.name !== 'sort_by') return;

      const component = target.closest(`${componentSelector}.kervelan-sort`);
      if (!(component instanceof HTMLElement) || !allowedSorts.has(target.value)) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      navigateToSort(target.value, component);
    },
    true
  );

  let observedRoot = null;

  const observer = new MutationObserver((mutations) => {
    const hasNewSortingComponent = mutations.some((mutation) =>
      Array.from(mutation.addedNodes).some((node) =>
        node instanceof Element && (node.matches('sorting-filter-component') || node.querySelector('sorting-filter-component'))
      )
    );

    if (hasNewSortingComponent) enhanceAll(observedRoot || document);
  });

  const bindObserver = () => {
    const nextRoot = document.querySelector(collectionSelector);
    if (!(nextRoot instanceof Element)) {
      observer.disconnect();
      observedRoot = null;
      return;
    }

    if (observedRoot === nextRoot) return;

    observer.disconnect();
    observedRoot = nextRoot;
    observer.observe(observedRoot, { childList: true, subtree: true });
  };

  const init = () => {
    enhanceAll();
    bindObserver();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    requestAnimationFrame(() => {
      enhanceAll(event.target);
      bindObserver();
    });
  });

  window.addEventListener('pageshow', (event) => {
    if (!event.persisted) return;
    init();
  });

  desktopQuery.addEventListener?.('change', () => {
    if (desktopQuery.matches) init();
  });
})();
